// Configurations for each report type
export const configs = {
  'Current Stream Status': {
    searchOptions: [
      { key: 'Stream Name', value: 'streamName' },
      { key: 'Description', value: 'description' },
      { key: 'Stream Profile', value: 'source' },
    ],
    tableColumns: [
      {
        field: 'name',
        headerName: 'Stream Name',
        type: 'string',
        grow: 0.8,
        sortable: true,
      },
      {
        field: 'description',
        headerName: 'Description',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'source',
        headerName: 'Stream Profile',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'appliance',
        headerName: 'Appliance Hostname',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'jurisdiction',
        headerName: 'Jurisdiction',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'status',
        headerName: 'Public Zone Status',
        type: 'string',
        grow: 1,
        sortable: true,
      },
    ],
  },
  'Camera Metadata': {
    searchOptions: [
      { key: 'Camera Name', value: 'cameraName' },
      { key: 'Description', value: 'description' },
      { key: 'Network Address', value: 'network_address' },
      { key: 'Latitude', value: 'latitude' },
      { key: 'Longitude', value: 'longitude' },
    ],
    tableColumns: [
      {
        field: 'name',
        headerName: 'Camera Name',
        type: 'string',
        grow: 0.8,
        sortable: true,
      },
      {
        field: 'description',
        headerName: 'Description',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'network_address',
        headerName: 'Network Address',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'connection_type',
        headerName: 'Connection Type',
        type: 'string',
        grow: 1,
        sortable: true,
        filterable: true,
      },
      {
        field: 'latitude',
        headerName: 'Latitude',
        type: 'number',
        grow: 1,
        sortable: true,
      },
      {
        field: 'longitude',
        headerName: 'Longitude',
        type: 'number',
        grow: 1,
        sortable: true,
      },
      {
        field: 'jurisdiction',
        headerName: 'Jurisdiction',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'routeName',
        headerName: 'Route Name',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'trafficDirection',
        headerName: 'Traffic Direction',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'mileMarker',
        headerName: 'Mile Marker',
        type: 'string',
        grow: 1,
        sortable: true,
      },
    ],
  },
  'Stream Network Config': {
    searchOptions: [
      { key: 'Stream Name', value: 'streamName' },
      { key: 'Description', value: 'description' },
      { key: 'Stream Input URL', value: 'streamInputUrl' },
      { key: 'Stream Input MCast', value: 'streamInputMcast' },
      { key: 'Stream Input Port', value: 'streamInputPort' },
    ],
    tableColumns: [
      {
        field: 'name',
        headerName: 'Stream Name',
        type: 'string',
        grow: 0.8,
        sortable: true,
      },
      {
        field: 'description',
        headerName: 'Description',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'appliance',
        headerName: 'Appliance Hostname',
        type: 'string',
        grow: 1,
        sortable: true,
        filterable: true,
      },
      {
        field: 'streamInputUrl',
        headerName: 'Stream Input URL',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'streamInputMcast',
        headerName: 'Stream Input MCast',
        type: 'string',
        grow: 1,
        sortable: true,
      },
      {
        field: 'streamInputPort',
        headerName: 'Stream Input Port',
        type: 'string',
        grow: 1,
        sortable: true,
      },
    ],
  },
};